import {createFileRoute} from '@tanstack/react-router';
import {BillPaymentPage} from 'features/bill-payment/pages/BillPaymentPage';

export const Route = createFileRoute('/_protected/bill-payment/$billId/')({
  component: BillPaymentPage,
});
